import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { compose } from 'recompose'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { connect as connectStaticText } from '../StaticText/connect'
import { H2, HEADING_TYPES } from '../Heading/index'
import EmailCapture from '../EmailCapture/index'

function DiscoverGaia (props) {
  const {
    staticText,
    emailSignupSuccess,
    doEmailSignup,
    formName,
    uiLocation,
  } = props
  return (
    <div className="discover-gaia">
      <div className="discover-gaia__wrapper">
        <div className="discover-gaia__info">
          <H2 as={HEADING_TYPES.H4}>
            {staticText.getIn(['data', 'discoverWhatGaiaHasToOffer'])}
          </H2>
          <div className="discover-gaia__description">
            {staticText.getIn(['data', 'discoverGaiaDescription'])}
          </div>
        </div>
        <div className="discover-gaia__email-capture-wrapper">
          <EmailCapture
            className={['discover-gaia__email-capture']}
            inputPlaceholder={staticText.getIn(['data', 'emailPlaceholder'])}
            onFormSubmit={doEmailSignup}
            formName={formName}
            siteSegment={Map()}
            buttonText={staticText.getIn(['data', 'signMeUp'])}
            success={emailSignupSuccess}
            inverted={false}
            name="discoverEmailSignup"
            uiLocation={uiLocation}
          />
        </div>
      </div>
    </div>
  )
}

DiscoverGaia.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  emailSignupSuccess: PropTypes.bool,
  doEmailSignup: PropTypes.func.isRequired,
  formName: PropTypes.string.isRequired,
  uiLocation: PropTypes.string,
}

export default compose(
  connectRedux(({
    emailSignup,
  }) => ({
    emailSignupSuccess: emailSignup.get('success'),
  }), (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      doEmailSignup: actions.emailSignup.doEmailSignup,
    }
  }),
  connectStaticText({ storeKey: 'discoverGaia' }),
)(DiscoverGaia)
